module.exports = __webpack_public_path__ + "img/welcome@2x.64617a77.jpg";